class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".custom-play--button");
    this.muteButton = this.querySelector(".custom-mute--button");
    this.video = this.querySelector("video");
    if (this.video) {
      this.load();
    }
  }

  load() {
    if (this.playButton && this.muteButton) {
      this.playButton.addEventListener("click", this.togglePlay.bind(this));
      this.muteButton.addEventListener("click", this.toggleMute.bind(this));
    }
  }

  togglePlay() {
    if (this.video) {
      if (this.video.paused || this.video.ended) {
        this.playButton.classList.add("paused");
        this.video.play();
      } else {
        this.playButton.classList.remove("paused");
        this.video.pause();
      }
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    if (this.video.muted === true) {
      this.muteButton.classList.add("muted");
    } else {
      this.muteButton.classList.remove("muted");
    }
  }
}

customElements.define("custom-video", CustomVideo);
